import React from 'react';
import { PauseModal } from '../../../../components/PauseModal';
import { PauseTypography } from '../../../../components/PauseTypography';

type PaymentSuccessModalProps = {
  open: boolean,
}
export const PaymentProcessingModal = ({
  open = false,
}: PaymentSuccessModalProps) => (
  <PauseModal
    width="15vw"
    open={open}
    onClose={() => null}
  >
    <div css={(theme) => ({
      display: 'grid',
      justifyContent: 'center',
      textAlign: 'center',
      gridAutoFlow: 'rows',
      gridGap: theme.spacing(2),
      padding: theme.spacing(3),
    })}
    >
      <div>
        <PauseTypography variant="title">
          Payment processing...
        </PauseTypography>
      </div>
      <div>
        <PauseTypography>
          Please wait as we process your payment. This should take just a few seconds.
        </PauseTypography>
      </div>
    </div>

  </PauseModal>
);
